import { c as _c } from "react/compiler-runtime";
import { animated } from '@react-spring/web';
import React, { FunctionComponent } from 'react';
import { Fade } from '../../animation/Fade/Fade';
import { prepareProps } from '../../utils/propUtils';
import { Spinner } from '../Spinner/Spinner';
import styles from './LoadingOverlay.module.css';
export type LoadingOverlayProps = {
  active: boolean;
};
export const LoadingOverlay: FunctionComponent<LoadingOverlayProps> = React.memo(props => {
  const $ = _c(10);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let active;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      active,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = active;
    $[4] = remainingProps;
  } else {
    active = $[3];
    remainingProps = $[4];
  }
  let t1;
  if ($[5] !== remainingProps) {
    t1 = style => <animated.div {...remainingProps} className={styles.backdrop} style={style}><Spinner className={styles.spinnerWrapper} /></animated.div>;
    $[5] = remainingProps;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== active || $[8] !== t1) {
    t2 = <Fade show={active}>{t1}</Fade>;
    $[7] = active;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
});